module.exports = __webpack_public_path__ + "img/minus-circle.9efaff68.svg";